import * as React from "react";

import { DropdownMenu } from "../Dropdown";
import { Metrics, Palette } from "../../vars";
import { StyledComponentClass } from "styled-components";

const StyledDropdownMenu: StyledComponentClass<any, any> = DropdownMenu.extend`
  top: 100%;
  padding: ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_Y}px
    ${Metrics.Padding.NAVBAR_DROPDOWN_MENU_X}px;
  background-color: ${Palette.NAVBAR_DROPDOWN_MENU_BG};
  color: ${Palette.NAVBAR_DROPDOWN_MENU_ITEM_TEXT};
  font-size: ${Metrics.FontSizes.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
  line-height: ${Metrics.LineHeights.NAVBAR_DROPDOWN_MENU_ITEM_TEXT}px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);

  .md-icon {
    position: absolute;
    right: 13px;
    top: 16px;
    cursor: pointer;

    i:before {
      color: ${Palette.Rebrand.Colours.P2};
    }
  }
`;

const NavbarDropdownMenu: React.SFC<any> = ({
  children,
  open,
  onCloseButtonClick
}) => (
  <StyledDropdownMenu
    center
    onCloseButtonClick={onCloseButtonClick}
    open={open}
    width={Metrics.Widths.NAVBAR_DROPDOWN_MENU}
  >
    <div>{children}</div>
    <i className="md-icon" role="closeDropdownButton">
      close
    </i>
  </StyledDropdownMenu>
);

export default NavbarDropdownMenu;
